// extracted by mini-css-extract-plugin
export default {"undo-changes-btn":"styles_undo-changes-btn__dI64b"};